module.exports = __webpack_public_path__ + "static/media/success-payment-icon.8ee6c343.svg";